import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";

@Component({
  selector: 'app-expandable',
  templateUrl: './expandable.component.html',
  styleUrls: ['./expandable.component.scss']
})
export class ExpandableComponent extends BaseComponent implements OnInit {

  showMore: boolean = false;
  showLess: boolean = false;
  @Input() textContent: string = "";
  maxTextLength: number = window.innerWidth < 1200 ? 200 : 400;
  textToDisplay: string = "";

  constructor() {
    super();
  }

  ngOnInit() {
    if(this.textContent) {
      if(this.textContent.length > this.maxTextLength) {
        this.cutText();
        this.showMore = true;
        this.showLess = false;
      }
      else {
        this.unCutText();
        this.showMore = false;
        this.showLess = false;
      }
    }
  }

  cutText() {
    this.textToDisplay = this.textContent.substr(0, this.maxTextLength) + "...";
  }

  unCutText() {
    this.textToDisplay = this.textContent;
  }

  more() {
    this.unCutText();
    this.showLess = true;
    this.showMore = false;
  }

  less() {
    this.cutText();
    this.showMore = true;
    this.showLess = false;
  }

}
